import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Box, Button, Typography } from '@mui/material';
import BrandLogo from '../brand/BrandLogo';
import { focusRing, scrollToId } from './landingStyles';

const LoginHero: React.FC = () => {
  return (
    <Box sx={{ minWidth: 0 }}>
      <Typography
        variant="overline"
        sx={{ fontWeight: 800, letterSpacing: 1.2, color: 'text.secondary', display: 'block', mb: 1 }}
      >
        Real estate investing, made clearer
      </Typography>
      <Typography
        variant="h3"
        component="h1"
        sx={{
          fontWeight: 800,
          letterSpacing: '-0.03em',
          fontSize: { xs: '2.15rem', sm: '2.75rem', md: '3.25rem' },
          lineHeight: 1.05,
          mb: 2,
          maxWidth: 640,
        }}
      >
        Find. Analyze.
        <Box
          component="span"
          sx={{
            display: 'block',
            borderBottom: '4px solid',
            borderColor: 'brand.yellow',
            width: 'fit-content',
            pb: 0.25,
          }}
        >
          Invest with confidence.
        </Box>
      </Typography>
      <Typography
        variant="body1"
        color="text.secondary"
        sx={{ fontSize: { xs: '1.02rem', md: '1.125rem' }, maxWidth: 560, mb: 3 }}
      >
        DealSkout gives real estate investors the tools to analyze opportunities, compare comparable
        sales, stress-test assumptions, review risks, organize deals, and understand the numbers
        behind the investment.
      </Typography>
      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1.5, mb: 1.5 }}>
        <Button
          component={RouterLink}
          to="/signup"
          variant="contained"
          color="primary"
          size="large"
          sx={focusRing}
        >
          Start free
        </Button>
        <Button
          component="a"
          href="#how-it-works"
          variant="outlined"
          color="primary"
          size="large"
          onClick={(event: React.MouseEvent) => {
            event.preventDefault();
            scrollToId('how-it-works');
          }}
          sx={focusRing}
        >
          See how it works
        </Button>
      </Box>
      <Typography variant="body2" sx={{ fontWeight: 700 }}>
        No credit card required.
      </Typography>
    </Box>
  );
};

export const HeroMascot: React.FC = () => (
  <Box
    sx={{
      display: 'inline-flex',
      bgcolor: '#FFFFFF',
      borderRadius: 3,
      p: 1,
      boxShadow: 1,
      border: '1px solid',
      borderColor: 'divider',
    }}
  >
    <BrandLogo variant="mark" height={88} />
  </Box>
);

export default LoginHero;
